import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { DropdownComponent } from '../../ui/dropdown/dropdown.component';
import { TooltipComponent } from '../../ui/tootip/tootip.component';
import { FeedbackService } from '../../../services/feedback.service';

@Component({
  selector: 'app-feedback-button',
  templateUrl: './feedback-button.component.html',
  imports: [CommonModule, FormsModule, DropdownComponent, TooltipComponent]
})
export class FeedbackButtonComponent {
  isOpen = false;
  isSubmitting = false;
  submitted = false;
  feedbackText = '';

  private feedbackService = inject(FeedbackService);
  private toastr = inject(ToastrService);

  toggle() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.submitted = false;
      this.feedbackText = '';
    }
  }

  close() {
    this.isOpen = false;
  }

  canSubmit(): boolean {
    return this.feedbackText.trim().length > 0 && !this.isSubmitting;
  }

  submit() {
    if (!this.canSubmit()) return;
    this.isSubmitting = true;
    this.feedbackService.submit(this.feedbackText.trim(), window.location.href).subscribe({
      next: () => {
        this.submitted = true;
        this.isSubmitting = false;
      },
      error: () => {
        this.isSubmitting = false;
        this.toastr.error('Could not submit feedback. Please try again.');
      }
    });
  }
}
